<template>
  <CloseCircleButtonModal
    class="gift-info-modal"
    title-text="ギフトについて"
    @clicked-modal-cover="onClickModalCover"
    @clicked-close="onClickCloseButton"
  >
    <div class="gift-info-modal__content">
      <KittyHtmlSanitized
        additional-class="gift-info-modal__body"
        :html="descriptionHtml"
      />
    </div>
  </CloseCircleButtonModal>
</template>

<script>
import CloseCircleButtonModal from '../../../../molecules/modals/CloseCircleButtonModal.vue'
import KittyHtmlSanitized from '../../../../atoms/html/KittyHtmlSanitized.vue'

export default {
  name: 'GiftInfoModal',
  components: {
    CloseCircleButtonModal,
    KittyHtmlSanitized
  },
  props: {
    descriptionHtml: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-info-modal {
  :deep(.close-circle-button-modal__content) {
    max-height: calc(100vh - 96px);
    max-width: 736px;

    @media all and (max-width: ($base-contents-width - 32)) {
      max-width: calc(100vw - 32px);
    }
  }

  :deep(.close-circle-button-modal__body) {
    overflow-y: auto;
  }
}

.gift-info-modal__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.gift-info-modal__body {
  width: 100%;

  :deep(*) {
    box-sizing: border-box;
  }
}
</style>
